import { useState, useEffect, createContext, useContext, useRef } from "react";
import io from "socket.io-client";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { useSelector } from "react-redux";
import { encryptMessages } from "../CoreDataService";

const SERVER_URL = "https://chat.paybito.com:8080/"; // your server URL

// Create context to share socket state
const ChatContext = createContext();

export const useChat = () => {
  return useContext(ChatContext);
};

export const ChatProvider = ({ children }) => {
  const { p2pbuySellDetails } = useSelector((state) => state);
  const [socket, setSocket] = useState(null);
  const [message, setMessage] = useState("");
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [onlineBroker, setOnlineBroker] = useState([]);
  const [p2pmessage, setP2pMessage] = useState("");
  const [p2pmessageCustomer, setP2pMessageCustomer] = useState("");
  const [p2pmessageCustomerAppeal, setP2pMessageCustomerAppeal] = useState("");
  const groupMessages = [];
  const [previousOrderId, setPreviousOrderId] = useState();

  const messageCountSubjectsRef = useRef({});
  useEffect(() => {
    setPreviousOrderId(
      p2pbuySellDetails?.orderId || localStorage.getItem("previousOrderId")
    );
  }, [p2pbuySellDetails]);

  console.log("previousOrderId--->", previousOrderId);

  console.log("all messages--->", message, p2pmessage, p2pmessageCustomer);

  useEffect(() => {
    // Initialize socket connection when component mounts
    const socketConnection = io(SERVER_URL);

    setSocket(socketConnection);

    // Cleanup on unmount
    return () => {
      socketConnection.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket) {
      // Set up socket listeners when socket is connected
      const uuid = localStorage.getItem("uuid");

      socket.on(`${uuid}-chat`, (message) => {
        console.log("get msg from", message);
        setMessage(message);
      });
      socket.on(`${previousOrderId}-chat`, (message) => {
        console.log("get msg from", message);
        setP2pMessage(message);
      });

      socket.on(`${previousOrderId}-chat-customer`, (message) => {
        setP2pMessageCustomer(message);
      });

      socket.on(`${previousOrderId}-chat-customer-appeal`, (message) => {
        setP2pMessageCustomerAppeal(message);
      });

      socket.on("getonlinetrader", (message) => {
        setOnlineUsers(message);
      });

      socket.on("getonlineuser", (message) => {
        setOnlineBroker(message);
      });

      return () => {
        socket.off(`${uuid}-chat`);
        socket.off(`${previousOrderId}-chat`);
        socket.off(`${previousOrderId}-chat-customer`);
        socket.off(`${previousOrderId}-chat-customer-appeal`);
        socket.off("getonlinetrader");
        socket.off("getonlineuser");
      };
    }
  }, [socket, previousOrderId]);

  const makeUserOnline = (message) => {
    if (socket) {
      socket.emit("sendonlinetrader", message);
    }
  };

  const sendMessageToUser = (message, data) => {
    if (socket) {
      socket.emit(message, data);
    }
  };

  const sendTypingSocket = (message, data) => {
    if (socket) {
      socket.emit(message, data);
    }
  };

  // ✅ Converted version of getMessageCount(uuid)
  const getMessageCount = (uuid) => {
    if (!socket) return null;

    const eventKey = `${uuid}-messagecount`;
    console.log("new message count called", uuid);
    console.log("new message DATA", eventKey);

    // Clean up existing listener if already present
    if (messageCountSubjectsRef.current[eventKey]) {
      socket.off(eventKey);
    }

    // Create a new Subject
    const subject = new Subject();

    // Listen to socket messages
    socket.on(eventKey, (data) => {
      subject.next(data);
    });

    // Save subject for cleanup later
    messageCountSubjectsRef.current[eventKey] = subject;

    // Return observable to component
    return subject.asObservable();
  };

  const groupMessageJoinRoom = (groupId) => {
    if (socket) {
      socket.emit("joinGroupChatRoom", groupId);
    }
  };

  const getMessagesFromSocket = (groupId) => {
    const eventKey = `${groupId}-groupchat`;

    return new Observable((observer) => {
      const handler = (data) => observer.next(data);

      socket.off(eventKey); // Remove previous listener if any
      socket.on(eventKey, handler);

      return () => {
        socket.off(eventKey, handler); // Cleanup when unsubscribed
      };
    });
  };

  const getTypingEvent = (groupId) => {
    const eventKey = `${groupId}-typing`;

    return new Observable((observer) => {
      const handler = (data) => observer.next(data);

      socket.off(eventKey); // Remove previous listener if any
      socket.on(eventKey, handler);

      return () => {
        socket.off(eventKey, handler); // Cleanup when unsubscribed
      };
    });
  };

  return (
    <ChatContext.Provider
      value={{
        message,
        onlineUsers,
        onlineBroker,
        p2pmessage,
        p2pmessageCustomer,
        p2pmessageCustomerAppeal,
        makeUserOnline,
        sendMessageToUser,
        getMessageCount,
        groupMessageJoinRoom,
        getMessagesFromSocket,
        getTypingEvent,
        groupMessages,
        sendTypingSocket,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
